var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var PlaceholderInfo = /** @class */ (function (_super) {
    __extends(PlaceholderInfo, _super);
    function PlaceholderInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlaceholderInfo.prototype.render = function () {
        return (React.createElement("div", { className: "rj-ev-list__placeholder__player-info" },
            React.createElement("div", { className: "rj-ev-list__placeholder__player-names-wrap" },
                React.createElement("div", { className: "rj-ev-list__placeholder__player-name" }),
                React.createElement("div", { className: "rj-ev-list__placeholder__player-name" })),
            React.createElement("div", { className: "rj-ev-list__placeholder__card-item-icon" })));
    };
    return PlaceholderInfo;
}(React.PureComponent));
export { PlaceholderInfo };
//# sourceMappingURL=PlaceholderInfo.js.map